module.exports = __webpack_public_path__ + "static/media/arc00.6947fc5a.png";